import { useState } from "react"
import { services } from "../data/services"
import Underline from "../components/Underline"

const Services = () => {
  // eslint-disable-next-line
  const [cards, setCards] = useState(services)

  return (
    <>
      <section className="services">
        <div className="services-overlay flex flex-col items-center justify-center">
          <h1 className="font-semibold text-4xl text-white mb-2 md:text-5xl lg:text-6xl 2xl:text-7xl">
            Services
          </h1>
          <Underline />
        </div>
      </section>

      <section className="bg-gray-100 pt-10 pb-20 px-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:px-40">
        {cards.map((card) => {
          const { id, image, title, desc } = card

          return (
            <article
              key={id}
              className="p-5 bg-white shadow-lg transition-all duration-300 hover:shadow-sm"
            >
              <img src={image} alt="" />
              <h4 className="font-bold mt-2 text-xl">{title}</h4>
              <p>{desc}</p>
            </article>
          )
        })}
      </section>
    </>
  )
}

export default Services
